 // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAbqyf5rcCIg84h0yY08DJZ33PsJT5Xays",
  authDomain: "formulaire-9b7b0.firebaseapp.com",
  projectId: "formulaire-9b7b0",
  storageBucket: "formulaire-9b7b0.appspot.com",
  messagingSenderId: "141698811371",
  appId: "1:141698811371:web:3c207dde4b7a41b7b305ae",
  measurementId: "G-Z1WYTTVYGN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);